import { Box, HStack, Pressable, Text, VStack } from "native-base";
import React from "react";

import RoundedLogo from "@/components/atoms/RoundedLogo";
import { useAppNavigation } from "@/hooks/application/navigation";
import { Store } from "@/interfaces/domain/Store";
import { HomeNavigation } from "@/navigation/stacks/HomeStack";
import { image_path_stores } from "@/services/api";
import { formatToCurrency } from "@/utils/helpers";

type StoreCardProps = {
  store: Store;
};

const StoreCard = ({ store }: StoreCardProps) => {
  const { navigate } = useAppNavigation<HomeNavigation>();
  const imageUrl = `${image_path_stores}/${store.foto_estabelecimento}`;
  const inactive = store?.status === "Fechado" || store?.fora_da_area;
  return (
    <Pressable onPress={() => navigate("storeHome", { storeId: store._id })}>
      <HStack
        p="2"
        px="2"
        my="2"
        justifyContent="space-between"
        alignItems="center"
        space={2}
        bgColor="white.50"
        shadow="4"
        rounded="md">
        <Box flex={0.3}>
          <RoundedLogo logoUrl={imageUrl} inactive={inactive} />
        </Box>
        <VStack flex={0.7} opacity={inactive ? 0.4 : undefined} flexShrink={1}>
          <Text bold fontSize="md" color={"text.600"} noOfLines={2}>
            {store.nome_fantasia}
          </Text>
          <Text color={"text.600"} noOfLines={2}>
            {store.tipo?.nome}
          </Text>
          {inactive && (
            <Text color="red.400">{store.fora_da_area ? "Não atende a região" : "Fechado"}</Text>
          )}
          {!inactive && typeof store.valor_frete === "number" && (
            <Text color={"text.400"} noOfLines={2}>
              Frete: {store.valor_frete === 0 ? "Grátis" : formatToCurrency(store.valor_frete)}
            </Text>
          )}
        </VStack>
      </HStack>
    </Pressable>
  );
};

export default StoreCard;
